module.exports = "/_next/static/images/vector-pattern-d688dd47fa9f8ec0941db8932d38eb68.svg";